import React, { PropsWithChildren, ReactChild } from "react";
import Link from "next/link";
import Title from "ui/Title/Title";
import containerStyles from "ui/Container/Container.module.scss";
import Slider, { Props as CustomSliderProps } from "common/Slider/Slider";
import ChevronRightRound from "assets/icons/chevron-right-round.svg";
import { LinkProps } from "helpers/url";
import { cn } from "helpers/style";
import styles from "./ProductsSlider.module.scss";

type Props = PropsWithChildren<{
  title: ReactChild;
  linkProps?: LinkProps;
  linkText?: string;
  sliderProps?: CustomSliderProps;
  className?: string;
}>;

const ProductsSlider: React.FC<Props> = ({
  title,
  linkText = "Все товары",
  linkProps,
  sliderProps,
  className,
  children,
}: Props) => {
  return (
    <div
      className={cn([
        containerStyles.container,
        styles.productSlider,
        className,
      ])}
    >
      <div className={styles.productSliderHeading}>
        <Title as="h2" size="h2">
          {title}
        </Title>
        {linkProps && (
          <Link {...linkProps}>
            <span className={styles.productSliderLink}>
              {linkText}
              <ChevronRightRound />
            </span>
          </Link>
        )}
      </div>
      <Slider
        className={styles.productSliderSliderContainer}
        noSwipingSelector="button"
        {...sliderProps}
      >
        {React.Children.map(children, (item, i) => {
          return (
            <div className={styles.productSliderProduct} key={`wrapper-${i}`}>
              {item}
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default ProductsSlider;
